import React, { useState, FC, ChangeEvent } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

interface PasswordFieldProps {
  label: string;
  id: string;
  name: string;
  autoComplete: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string;
  dataTestId?: string;
}

export const PasswordField: FC<PasswordFieldProps> = ({
  label,
  id,
  name,
  autoComplete,
  value,
  onChange,
  error,
  helperText,
  dataTestId,
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [inputType, setInputType] = useState<string>("password");

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
    setInputType(showPassword ? "password" : "text");
  };

  return (
    <TextField
      margin="normal"
      required
      fullWidth
      name={name}
      label={label}
      type={inputType || "password"}
      id={id}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
      inputProps={{ "data-testid": dataTestId }}
      InputProps={{
        className: "textfield-typography-label",
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleTogglePasswordVisibility}>
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        className: "textfield-typography-props",
      }}
      error={error}
      helperText={helperText}
      variant="standard"
    />
  );
};
